
import {
    FETCH_LEARNING_HUB_REQUEST,
    FETCH_LEARNING_HUB_SUCCESS,
    FETCH_LEARNING_HUB_FAILURE,

    UPDATE_VIDEO_STATUS_REQUEST,
    UPDATE_VIDEO_STATUS_SUCCESS,
    UPDATE_VIDEO_STATUS_FAILURE,
    RESET_UPDATE_VIDEO_STATUS_SUCCESS
} from '../../../Constants/actionTypes';

const initialState = {
    loading: false,
    getData: null,
    videoStatus: null,
    error: null,
};

const learningHubReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_LEARNING_HUB_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case FETCH_LEARNING_HUB_SUCCESS:
            return {
                ...state,
                loading: false,
                getData: action.payload,
            };
        case FETCH_LEARNING_HUB_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case UPDATE_VIDEO_STATUS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case UPDATE_VIDEO_STATUS_SUCCESS:
            return {
                ...state,
                loading: false,
                videoStatus: action.payload,
            };
        case UPDATE_VIDEO_STATUS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
       
        default:
            return state;
    }
};

export default learningHubReducer;
